import { FC } from 'react'
import {toAbsoluteUrl} from '../../../_metronic/helpers';
import { PurchaceReturnOrders } from '../../modules/orders/PurchaseReturnOrders';

interface Props {
  readOnly?: boolean
}

const ReturnOrdersPage: FC<Props> = ({readOnly = false}) => (
  <>
    {/* begin::Row */}
    <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
      {/* begin::Col */}
      <div className='col-md-12 col-lg-12 mb-md-5 mb-xl-10'>
        <PurchaceReturnOrders />
        {/* TODO: Add read-only mode support to PurchaceReturnOrders component */}
      </div>
      {/* end::Col */}
    </div>
    {/* begin::Row */}
  </>
)

const ReturnOrders: FC<Props> = ({readOnly = false}) => {
  return (
    <>
      <ReturnOrdersPage readOnly={readOnly} />
    </>
  )
}

export default ReturnOrders